export default "__VITE_ASSET__MHWN3MB3__"